export default "__VITE_PUBLIC_ASSET__c93b9d86__"